import $script from 'scriptjs';

let promise;

export function loadGoogleVisualizationApi() {
    return promise ? promise : promise = new Promise((resolve) => {
        $script('https://www.google.com/jsapi', () => {
            window.google.load('visualization', '1', {
                packages: ['corechart'],
                callback: () => resolve(window.google)
            });
        });
    });
}



// WEBPACK FOOTER //
// ./src/portal/lib/load-google-visualization-api.js